namespace bannerEnum {
  export enum Banner {
    homeSlider1 = 'اسلایدر اول صفحه اصلی',
    homeSlider2 = 'اسلایدر دوم صفحه اصلی',
    homeSlider3 = 'اسلایدر سوم صفحه اصلی',
    homeCard1 = 'کارت اول صفحه اصلی',
    homeCard2 = 'کارت دوم صفحه اصلی',
    homeCard3 = 'کارت سوم صفحه اصلی',
    brandCard1 = 'کارت اول برند صفحه اصلی',
    brandCard2 = 'کارت دوم برند صفحه اصلی',
    brandCard3 = 'کارت سوم برند صفحه اصلی',
    categoryCard1 = 'کارت اول دسته بندی صفحه اصلی',
    categoryCard2 = 'کارت دوم دسته بندی صفحه اصلی',
    categoryCard3 = 'کارت سوم دسته بندی صفحه اصلی',
    carCard1 = 'کارت اول ماشین صفحه اصلی',
    carCard2 = 'کارت دوم ماشین صفحه اصلی',
    carCard3 = 'کارت سوم ماشین صفحه اصلی',
  }
}
export default bannerEnum;
